export const environment = {
  production: true,
  adal: {
    enabled: true,
    clientId: '192bd8f2-c844-4977-aefd-77407619e80c',
  }
};
